import React from 'react';

import { Circle, CircleDot, Cog, EyeIcon, EyeOffIcon } from 'lucide-react';

import { Switch } from '@/components/shadcn/ui/switch';
import { useGlobalSettingsStore } from '@/shared';

import { HeaderMenuDrawerCollapsible, HeaderMenuDrawerSingle } from '../HeaderMenuDrawerComponents';

const HeaderMenuDrawerSettings: React.FC = () => {
  const { isHistoryVisibleInSwapPanel, isManualBtcUtxosSelection, isManualLtcUtxosSelection, setUiSettings } =
    useGlobalSettingsStore();

  return (
    <HeaderMenuDrawerCollapsible Icon={Cog} label="Settings">
      <HeaderMenuDrawerSingle
        Icon={isHistoryVisibleInSwapPanel ? EyeIcon : EyeOffIcon}
        onClick={() => {
          setUiSettings({ isHistoryVisibleInSwapPanel: !isHistoryVisibleInSwapPanel });
        }}
      >
        <div className="flex w-full items-center justify-between">
          History in Swap Panel
          <Switch size="sm" checked={isHistoryVisibleInSwapPanel} />
        </div>
      </HeaderMenuDrawerSingle>
      <HeaderMenuDrawerSingle
        Icon={isManualBtcUtxosSelection ? CircleDot : Circle}
        onClick={() => {
          setUiSettings({ isManualBtcUtxosSelection: !isManualBtcUtxosSelection });
        }}
      >
        <div className="flex w-full items-center justify-between">
          Bitcoin UTXO Selection
          <Switch size="sm" checked={isManualBtcUtxosSelection} />
        </div>
      </HeaderMenuDrawerSingle>
      <HeaderMenuDrawerSingle
        Icon={isManualLtcUtxosSelection ? CircleDot : Circle}
        onClick={() => {
          setUiSettings({ isManualLtcUtxosSelection: !isManualLtcUtxosSelection });
        }}
      >
        <div className="flex w-full items-center justify-between">
          Litecoin UTXO Selection
          <Switch size="sm" checked={isManualLtcUtxosSelection} />
        </div>
      </HeaderMenuDrawerSingle>
    </HeaderMenuDrawerCollapsible>
  );
};

export default HeaderMenuDrawerSettings;
